import React, { useState } from "react";
import {
  COOKIE_CONSENT,
  hasCookieConsentChoice,
  setCookieConsent,
} from "../../utils/cookieConsent";
import "./CookieConsent.scss";

const CookieIcon = () => (
  <svg
    className="cookie-consent__icon"
    viewBox="0 0 48 48"
    width="48"
    height="48"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="24" cy="24" r="24" fill="#59a638" />
    <circle cx="24" cy="24" r="14" fill="#ffffff" opacity="0.15" />
    <circle cx="18" cy="18" r="2.2" fill="#ffffff" />
    <circle cx="28" cy="16" r="1.8" fill="#ffffff" />
    <circle cx="32" cy="24" r="2.4" fill="#ffffff" />
    <circle cx="22" cy="28" r="1.6" fill="#ffffff" />
    <circle cx="16" cy="30" r="1.9" fill="#ffffff" />
    <circle cx="27" cy="32" r="2.1" fill="#ffffff" />
  </svg>
);

const CookieConsent = () => {
  const [visible, setVisible] = useState(() => !hasCookieConsentChoice());

  if (!visible) {
    return null;
  }

  const handleChoice = (value) => {
    setCookieConsent(value);
    setVisible(false);
  };

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div className="cookie-consent__content">
        <CookieIcon />
        <div className="cookie-consent__text">
          <h2 id="cookie-consent-title" className="cookie-consent__title">
            We Value Your Privacy
          </h2>
          <p id="cookie-consent-description" className="cookie-consent__body">
            We use cookies to ensure our application functions securely, remember
            your preferences, and improve your experience. Essential cookies are
            always active because they are necessary for the application to
            operate. With your consent, we may also use non-essential cookies to
            analyze usage and enhance our services. You can choose to accept all
            cookies or reject all cookies.
          </p>
        </div>
      </div>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--accept"
          onClick={() => handleChoice(COOKIE_CONSENT.ACCEPTED)}
        >
          Accept All
        </button>
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--reject"
          onClick={() => handleChoice(COOKIE_CONSENT.REJECTED)}
        >
          Reject All
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
